export const INTEGRATION_SYNC_BCMS = 'INTEGRATION_SYNC_BCMS';
export const INTEGRATION_SYNC_AGRIWEBB = 'INTEGRATION_SYNC_AGRIWEBB';
